const queue = {
  data: [],
  waiting: false
};

const getWindow = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  return window;
};

const productViewHasBeenTriggered = () =>
  (getWindow().dataLayer || []).find(e => e.event === 'Ecommerce Detail Impression');

const pageNeedsProductView = () => {
  const element = document.querySelectorAll('.site-container')[0];
  if (!element) {
    return false;
  }

  return (
    element.classList.contains('page-type-selector--yacht_for_charter') ||
    element.classList.contains('page-type-selector--yacht_for_sale')
  );
};

const productViewIsInQueue = () => (queue.data[0] || {}).event === 'Ecommerce Detail Impression';

const pageViewHasBeenTriggered = () => {
  const event = (getWindow().dataLayer || []).find(e => e.event === 'pageView');
  if (!event) {
    return false;
  }

  return event.url === `${getWindow().location.pathname}${getWindow().location.search}`;
};

const pushInternal = payload => {
  const window = getWindow();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

const enqueue = payload => {
  if (payload.event === 'Ecommerce Detail Impression') {
    queue.data.unshift(payload);
  } else {
    queue.data.push(payload);
  }
};

const isReadyToRelease = () => {
  if (!pageViewHasBeenTriggered()) {
    return false;
  }

  if (!pageNeedsProductView()) {
    return true;
  }

  return !!(productViewIsInQueue() || productViewHasBeenTriggered());
};

const releaseQueue = () => {
  while (queue.data.length > 0) {
    pushInternal(queue.data.shift());
  }

  queue.waiting = false;
};

const checkQueue = () => {
  if (queue.data.length === 0 || isReadyToRelease()) {
    releaseQueue();
    return;
  }

  if (queue.waiting) {
    return;
  }

  queue.waiting = true;

  setTimeout(() => {
    queue.waiting = false;
    checkQueue();
  }, 500);
};

const pushToDataLayer = payload => {
  if (typeof window === 'undefined' || !payload) {
    return;
  }

  enqueue(payload);
  checkQueue();
};

export default pushToDataLayer;
